<template>
  <a-spin tip="loading" v-if="loading" id="loading" size="large">
    <div class="spin-content"></div>
  </a-spin>
  <div class="working-wall-detail" v-else>
    <header>
      <a-row class="header">
        <a-col :span="3" class="header-right">
          <i @click="$router.go(-1)"></i>
        </a-col>
        <a-col :span="18" class="header-title">
          <span>{{ $t("workingWall.AssignmentDetails") }}</span>
        </a-col>
      </a-row>
    </header>
    <div :class="is_show ? 'pos_top' : ''">
      <div class="row" @touchmove.prevent>
        <div class="row-img">
          <img
            :src="datas.avatar != '' ? datas.avatar : defaultImg"
            alt
            :onerror="errorImg"
          />
        </div>
        <div class="row-right">
          <h1>{{ datas.resources_name }}</h1>
          <div class="row-bottom">
            <div class="row-bottom-one">
              <span class="row-name"
                >{{ datas.username }}{{ $t("workingWall.Postedat") }}</span
              >
              <span>{{ datas.created_at }}</span>
            </div>
            <div class="row-bottom-two">
              <div class="row-click">
                <i></i>
                {{ datas.click_num }}
              </div>
              <div class="row-praise" @click="praise">
                <i :class="datas.is_praise == 0 ? 'unpraise' : 'praised'"></i>
                {{ datas.praise_num }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="pos">
        <div class="detail">
          <div class="title">{{ $t("workingWall. AssignmentDetails") }}</div>
          <div class="btn" @click="show_des">
            {{ text }}
            <i class="down"></i>
          </div>
        </div>
        <div class="des" v-show="is_show">
          <div class="bg-color">
            <div class="first-des">
              <div class="title">
                <i class="dotted"></i>
                {{ $t("workingWall. AssignmentDes") }}
              </div>
              <p v-if="datas.info != ''">{{ datas.info }}</p>
            </div>
            <div class="first-des second-des" v-if="datas.homework_url != ''">
              <div class="title">
                <i class="dotted"></i>
                {{ $t("workingWall. AssignmentSee") }}
                <span
                  v-if="
                    datas.file_extension == 'zip' ||
                    datas.file_extension == 'rar'
                  "
                >
                  <i></i>
                  {{ $t("workingWall. AssignmentNotSup") }}
                </span>
              </div>
              <div
                :class="
                  datas.file_extension == 'zip' || datas.file_extension == 'rar'
                    ? 'unname'
                    : 'name'
                "
                @click="go_detail(datas.file_extension, datas.homework_url)"
                v-text="
                  datas.file_name == ''
                    ? $t('workingWall. Enclosure')
                    : datas.file_name
                "
              ></div>
            </div>
          </div>
        </div>
      </div>
      <div class="content">
        <div class="title">{{ $t("workingWall. Answer") }}</div>
        <MyAliplayer
          :video1="video"
          :videoHeight="videoHeight"
          :videoDetail="datas.myfile"
        ></MyAliplayer>
      </div>
    </div>
    <!-- 评论列表 -->
    <!-- <comment></comment> -->
    <div class="detail-bottom">
      <router-link
        tag="div"
        class="more-comment"
        :to="{ path: '/main/commentList', query: { id: datas.id } }"
      >
        <img src="../../assets/img/working-wall/more_k.png" />
        {{ $t("workingWall.MoreComments") }}
      </router-link>
      <router-link
        tag="div"
        class="write-comment"
        :to="{
          path: '/main/add_question',
          query: { id: datas.id, from: 'working_wall' },
        }"
      >
        <img src="../../assets/img/working-wall/comment_w.png" />
        {{ $t("workingWall.WriteAComment") }}
      </router-link>
    </div>
  </div>
</template>
<script>
import MyAliplayer from "components/MyAliplayer/index_working_wall.vue";
import defaultImg from "../../assets/img/learning_camp/basic_fc.png";
import { mapState } from "vuex";
export default {
  components: {
    MyAliplayer,
  },
  data() {
    return {
      defaultImg,
      errorImg:
        'this.src="' + require("@/assets/img/learning_camp/basic_fc.png") + '"',
      loading: true,
      datas: [],
      type: 0,
      video: {
        VideoId: 1,
        source:
          "https://vod.olympicchannel.com/NBCR_Production_-_OCS/233/968/GEPH-ONTHERECS02E015C-_E17101101_master.m3u8",
        Duration: "04:11",
      },
      videoHeight: "3.6rem",
      repeat_praise: true,
      text: this.$t("workingWall.more"),
    };
  },
  beforeRouteLeave(to, from, next) {
    // 可以直接获取this实例
    this.$store.commit("working_wall/is_show", false); // 切换菜单
    next();
  },
  computed: {
    ...mapState({
      is_show: (state) => state.working_wall.is_show,
    }),
  },
  created() {
    this.get_detail();
  },
  methods: {
    show_des() {
      if (this.text == this.$t("workingWall.more")) {
        // this.is_show = true;
        this.$store.commit("working_wall/is_show", true); // 切换菜单
        this.text = this.$t("workingWall.collapse");
        $(".btn").addClass("hoverd");
        $(".btn").find("i").removeClass("down").addClass("up");
        // $(".des").height(
        //   document.body.clientHeight - $("header").height() - $(".row").height() - $(".pos").height()-20
        // ) + "px";
      } else {
        // this.is_show = false;
        this.$store.commit("working_wall/is_show", false); // 切换菜单
        this.text = this.$t("workingWall.more");
        $(".btn").removeClass("hoverd");
        $(".btn").find("i").removeClass("up").addClass("down");
      }
    },
    go_detail(type) {
      if (type == "zip" || type == "rar") {
        this.$toast(this.$t("workingWall.AssignmentNotSup"));
      } else {
        this.$router.push({
          name: "sub_alfx_detail_yl",
          query: {
            fileUrl: this.datas.homework_url,
          },
        });
      }
    },
    get_detail() {
      var url = "index.php/mobile/homework/get-wall-detail";
      var params = {
        user_id: localStorage.getItem("_user_data_id"),
        company_id: localStorage.getItem("_user_data_company_id"),
        sso_token: localStorage.getItem("_user_data_sso_token"),
        sys_id: localStorage.getItem("_sys_id"),
        language: localStorage.getItem("_user_data_language"),
        id: this.$route.query.id,
      };
      this.$axios.post(url, params).then((res) => {
        this.loading = false;
        if (res.data.code == 0) {
          this.datas = res.data.result;
        } else {
          if (res.data.code == 10600) {
            this.$router.push({ name: "Login" });
          } else {
            this.$toast(res.data.msg);
          }
        }
      });
    },
    praise() {
      if (this.repeat_praise) {
        this.repeat_praise = false;
        // }
        var url = "index.php/mobile/homework/wall-praise";
        var params = {
          user_id: localStorage.getItem("_user_data_id"),
          company_id: localStorage.getItem("_user_data_company_id"),
          sso_token: localStorage.getItem("_user_data_sso_token"),
          sys_id: localStorage.getItem("_sys_id"),
          language: localStorage.getItem("_user_data_language"),
          item_id: this.datas.id,
          trainplan_id: this.datas.trainplan_id,
        };
        this.$axios.post(url, params).then((res) => {
          // console.log(res);
          this.repeat_praise = true;
          if (res.data.code == 0) {
            if (res.data.result.is_praise == 1) {
              this.datas.praise_num++;
              this.datas.is_praise = 1;
            } else {
              if (this.datas.praise_num > 0) {
                this.datas.praise_num--;
              }
              this.datas.is_praise = 0;
            }
          } else {
            if (res.data.code == 10600) {
              this.$router.push({ name: "Login" });
            } else {
              this.$toast(res.data.msg);
            }
          }
        });
      }
    },
  },
};
</script>
<style scoped lang="less">
.working-wall-detail {
  // width: 100%;
  height: 100%;
}
header {
  height: 0.7rem;
}
.header {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999999999;
  width: 100%;
  padding: 0.1rem 0.3rem;
  background: #f6f6f6;
  border-bottom: 0.01rem solid #ddd;
  display: flex;
  align-items: center;
  .header-title {
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      font-size: 0.32rem;
      color: #252631;
    }
    i {
      display: inline-block;
      width: 0.22rem;
      height: 0.03rem;
      background: #999999;
      margin: 0 0.1rem;
    }
  }
  .header-right {
    display: flex;
    align-items: center;
    i {
      display: inline-block;
      width: 0.18rem;
      height: 0.34rem;
      background: url("../../assets/img/facecourse/back.png") no-repeat
        center/contain;
      background-size: 100%;
    }
  }
}
.pos_top {
  //展开时
  position: fixed;
  left: 0;
  right: 0;
}
.row {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ddd;
  margin: 0.4rem 0.4rem 0 0.4rem;
  padding-bottom: 0.4rem;
  .row-img {
    img {
      width: 0.76rem;
      height: 0.76rem;
      border-radius: 50%;
      margin-right: 0.17rem;
      pointer-events: none; //防止图片点击放大
    }
  }
  .row-right {
    width: 100%;
    h1 {
      font-size: 0.4rem;
      font-weight: bold;
    }
    .row-bottom {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 0.07rem;
      .row-bottom-one {
        font-size: 0.22rem;
        .row-name {
          color: #005587;
          //   display: inline-block;
          //   max-width: 2.8rem;
          //   overflow: hidden;
          //   text-overflow: ellipsis;
          //   white-space: nowrap;
          //   vertical-align: top;
        }
      }
      .row-bottom-two {
        display: flex;
        align-items: center;
        .row-click {
          margin: 0 0.2rem;
          font-size: 0.22rem;
          i {
            display: inline-block;
            width: 0.33rem;
            height: 0.25rem;
            background: url("../../assets/img/working-wall/see.png") no-repeat
              center/contain;
            background-size: 100%;
            vertical-align: middle;
            margin-top: -0.05rem;
          }
        }
        .row-praise {
          font-size: 0.22rem;
          i {
            display: inline-block;
            width: 0.33rem;
            height: 0.25rem;
            // vertical-align: middle;
          }
          .unpraise {
            background: url("../../assets/img/working-wall/fav.png") no-repeat
              center/contain;
            background-size: 75%;
          }
          .praised {
            background: url("../../assets/img/working-wall/faved.png") no-repeat
              center/contain;
            background-size: 75%;
          }
        }
      }
    }
  }
}

.detail-bottom {
  display: flex;
  background: #005587;
  width: 100%;
  height: 0.9rem;
  position: fixed;
  bottom: 0;
  left: 0;
  color: #fff;
  font-size: 0.28rem;
  padding: 0.25rem 0;
  .more-comment {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50%;
    border-right: 1px solid #fff;
    img {
      width: 0.27rem;
      height: 0.05rem;
      margin-right: 0.15rem;
    }
  }
  .write-comment {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50%;
    img {
      width: 0.32rem;
      height: 0.3rem;
      margin-right: 0.15rem;
      vertical-align: middle;
    }
  }
}
.pos {
  position: relative;
  .detail {
    padding: 0.4rem 0;
    margin: 0 0.4rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ddd;

    .title {
      font-size: 0.3rem;
      color: #252631;
    }
    .btn {
      padding: 0.02rem 0.16rem;
      font-size: 0.22rem;
      color: #005587;
      border: 1px solid #005587;
      border-radius: 0.25rem;
      i {
        display: inline-block;
        height: 0.15rem;
        width: 0.1rem;
        margin-left: 0.05rem;
      }
      .down {
        background: url("../../assets/img/column_video/show.png") no-repeat
          center/contain;
        background-size: 100%;
      }
      .up {
        background: url("../../assets/img/working-wall/up.png") no-repeat
          center/contain;
        background-size: 100%;
      }
    }
    .hoverd {
      color: #fff;
      background: #005587;
    }
  }
  .des {
    position: fixed;
    background-color: rgba(0, 0, 0, 0.2);
    z-index: 9999999999;
    width: 100%;
    height: 100%;
    .bg-color {
      background-color: #fff;
      padding: 0.4rem 0.4rem 0.4rem 0.4rem;
    }
    .first-des {
      .title {
        font-size: 0.3rem;
        color: #252631;
        padding-bottom: 0.28rem;
        // background-color: #fff;
        .dotted {
          display: inline-block;
          width: 0.1rem;
          height: 0.1rem;
          border-radius: 50%;
          background: #000;
          margin-right: 0.2rem;
          vertical-align: middle;
        }
      }
      p {
        font-size: 0.26rem;
        padding-bottom: 0.4rem;
      }
    }
    .second-des {
      padding: 0.4rem 0;
      border-top: 1px solid #ddd;
      // background: #fff;
      span {
        font-size: 0.22rem;
        color: #f75d5d;
        i {
          display: inline-block;
          width: 0.22rem;
          height: 0.22rem;
          background: url("../../assets/img/learning_camp/undone.png") no-repeat
            center/contain;
          background-size: 100%;
          margin: 0 0.05rem;
        }
      }
      .name {
        border: 1px solid #005587;
        color: #005587;
        font-size: 0.28rem;
        padding: 0.1rem 0.3rem;
      }
      .unname {
        border: 1px solid #ddd;
        color: #999;
        font-size: 0.28rem;
        padding: 0.1rem 0.3rem;
      }
    }
  }
}
.content {
  padding: 0.3rem 0.4rem;
  .title {
    font-size: 0.3rem;
    color: #252631;
    margin-bottom: 0.2rem;
  }
}
.line {
  width: 100%;
  height: 0.2rem;
  background: #eee;
}
</style>
